/**
 * @author: lv.chen
 * @date: 2026/3/15
 * @desc: 变化指标下拉单选筛选器组件
 */
import React from 'react';
import classnames from 'classnames';
// import { useIntl } from 'umi';
import Select from '@intelligence/v3/components/FormComponents/Select';
import { reportButtonLog } from '@intelligence/v3/utils/logReporter';
import { dbiPageLogMes, dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';

import type { ISelectProps } from '@intelligence/v3/components/FormComponents/Select';

import ICON_TRENDS from '@intelligence/assets/svg/icon-trends-light.svg';

import './index.scss';

interface IChangedMetricSelectProps extends IBaseProps, ISelectProps {
  /**
   * 是否开启按钮打点
   */
  useBtnLog?: boolean;
  /**
   * 页面打点配置键，需要通过页面打点配置获取pageId、pageName 给 按钮打点用
   */
  pageLogKey?: string;
}

const reportSurgeMetricSelectLog = (pageLogKey: string, metric: string) => {
  const pageLogConfig = dbiPageLogMes[pageLogKey];
  const pageId = pageLogConfig?.pageId || '';

  if (pageId) {
    const pageName = pageLogConfig?.pageName || '';
    const surgeMetricSelectLogConfigBase = dbiBtnLogMes.surgeMetricSelect;
    const surgeMetricSelectLogExtInfo = surgeMetricSelectLogConfigBase?.extInfo || '';
    const surgeMetricSelectLogConfig = {
      ...surgeMetricSelectLogConfigBase,
      pageId,
      extInfo: `${surgeMetricSelectLogExtInfo} (${pageName}) (${metric})`,
    };

    reportButtonLog(surgeMetricSelectLogConfig);
  }
};

const ChangedMetricSelect: React.FC<IChangedMetricSelectProps> = (props) => {
  const { style, className, useBtnLog = true, pageLogKey, options = [], value, onChange, ...restProps } = props;

  // const { formatMessage } = useIntl();

  const handleChange = (value: string, context: any) => {
    if (useBtnLog) {
      if (value) {
        reportSurgeMetricSelectLog(pageLogKey, value);
      }
    }
    onChange?.(value, context);
  };

  return (
    <Select
      {...restProps}
      style={style}
      className={classnames('dbi-component-changed-metric-select', className)}
      clearable
      placeholder="dbi_show_rising_games"
      label={<img className="dbi-component-changed-metric-select__icon" src={ICON_TRENDS} alt="" />}
      options={options}
      value={value}
      onChange={handleChange}
    />
  );
};

export default ChangedMetricSelect;
